import { render, staticRenderFns } from "./wearGlasses.vue?vue&type=template&id=0d1f0278&scoped=true&"
import script from "./wearGlasses.vue?vue&type=script&lang=js&"
export * from "./wearGlasses.vue?vue&type=script&lang=js&"
import style0 from "./wearGlasses.vue?vue&type=style&index=0&id=0d1f0278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f0278",
  null
  
)

export default component.exports